import { useCallback } from "react";
function useDropdownProps(dispatch) {
  const onClick = useCallback(
    (event) => {
      event.stopPropagation();
      dispatch({ type: "dropdownItem:click", event });
    },
    // dispatch is a stable function, putting as a deps has no effect
    [dispatch]
  );
  return { onClick };
}
export {
  useDropdownProps
};
//# sourceMappingURL=useDropdownProps.js.map
